/**
 * Bottom section of the Help Center — always-visible direct contact info.
 * Serves as the escape hatch when the FAQ and chat can't resolve the issue.
 */

export function ContactSection() {
  return (
    <section className="help-contact-section">
      <h2 className="help-contact-title">📞 Still Need Help?</h2>
      <div className="help-contact-grid">
        <div className="help-contact-row">
          <span className="help-contact-label">Email:</span>
          <a className="help-contact-value" href="mailto:info@jadenterprises.org">
            info@jadenterprises.org
          </a>
        </div>
        <div className="help-contact-row">
          <span className="help-contact-label">Phone:</span>
          <a className="help-contact-value" href="tel:+12143042168">
            (214) 304-2168
          </a>
        </div>
      </div>
      <p className="help-contact-note">
        You can always contact us directly — we're here to help.
      </p>
    </section>
  );
}
